import { connect } from 'react-redux';
import { goBack, push } from 'connected-react-router';
import ExitPaymentSetup from './component';
import { closeNotification } from '@common/actions/NotificationActions';
import { getIreneDashboard } from '@rental-manager/actions/requests';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => ({
  propertyId,
});

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  exitPaymentSetup: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl)))
      .then(() => dispatch(getIreneDashboard({ propertyId }))),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExitPaymentSetup);
